import { observable, action, flow, set, toJS } from "mobx";
import {
	getProject,
	delay,
	registerHandler,
	generateRandomInfo,
	saveAccountCreationProject,
	downloadRankerXEmail,
	downloadEmailFromEmailList,
	saveSchedule,
	deleteSchedule,
	resetSchedule,
	startProject,
	stopProject,
	startVerifyingMails,
	stopVerifyingMails,
	testEmail,	
} from "services/api";

import { addAccountProfile } from "services/accountProfile";
import omit from "lodash/omit";
import uuidv1 from "uuid/v1";
import LZString from "lz-string";
import { message, notification, Modal } from "antd";
import _ from "lodash";
import { encrypt } from "common/abc";

export default class AcProjectStore {
	@observable
	project = {
		verificationInfo: {
			status: null
		},
		lastError: null
	};	

	@observable siblings = [];
	@observable profiles = [];
	@observable sites = [];
	@observable uuid = "";

	@observable
	ui = {
		loadingProject: true,
		editing: false,
		startingProject: false,
		stoppingProject: false,
		savingProject: false,
		addEditScheduleDialogVisible: false,
		addAccountProfileDialogVisible: false,
		startingVerifyingMails: false,
		stoppingVerifyingMails: false,
		generatingRandomInfo: false,
		downloadingRankerXEmail: false,
		downloadingEmailFromEmailList: false,
		testingEmail: false,
		savingProject: false,
		addingAccountProfile: false,
		deletingSchedule: false,
		resettingSchedule: false,
		updatedSite: null
	};

	@observable stateForm = {};

	backedUpSites = [];

	getInitUI = () => {
		return {
			loadingProject: false,
			editing: false,
			startingProject: false,
			stoppingProject: false,
			savingProject: false,
			addEditScheduleDialogVisible: false,
			addAccountProfileDialogVisible: false,
			startingVerifyingMails: false,
			stoppingVerifyingMails: false,
			generatingRandomInfo: false,
			downloadingRankerXEmail: false,
			downloadingEmailFromEmailList: false,
			testingEmail: false,
			savingProject: false,
			addingAccountProfile: false,
			deletingSchedule: false,
			resettingSchedule: false,
			updatedSite: null
		};
	};

	// @action
	// formChanged = fields => {
	// 	Object.assign(this.stateForm, fields);
	// 	let partialProject = this.getPartialProjectFromStateForm(this.stateForm);
	// 	Object.assign(this.projectViewModel, partialProject);
	// };

	customizer = (objValue, srcValue, key, object, source, stack) => {
		if (srcValue == undefined) {
			return null;
		}
	};

	@action
	formChanged = fields => {
		_.mergeWith(this.stateForm, fields, this.customizer);
	};

	@action
	startEditingProject = () => {
		this.ui.editing = true;
		this.backedUpSites = _.cloneDeep(this.sites.slice());
	};

	@action
	cancelEditingProject = () => {
		this.ui.editing = false;
		this.sites = observable.array(this.backedUpSites, { deep: false });
		this.backedUpSites = null;
		this.stateForm = this.createFormObject(this.project);
	};

	getRawObjectFromFormObject = formObject => {
		function customizer(value) {
			if (_.isObject(value)) {
				if ("value" in value) {
					return value.value;
				}
			}
		}
		let rawJS = toJS(formObject);
		return _.cloneDeepWith(rawJS, customizer);
	};

	@action
	saveProject = flow(function*(sites) {
		this.ui.savingProject = true;
		this.backedUpSites = null;

		let project = this.getRawObjectFromFormObject(this.stateForm);
		
		// let sites = this.sites;
		this.sites = observable.array(sites, { deep: false });
		
		let uuid = this.uuid;
		let jsonData = JSON.stringify({
			project: project,
			sites: sites,
			uuid: uuid
		});

		let compressedData = LZString.compressToEncodedURIComponent(jsonData);
		let encryptedData = encrypt(compressedData);

		const response = yield saveAccountCreationProject(encryptedData);

		this.project = observable.object(project);

		this.ui.savingProject = false;		

		if (response == null) {
			message.error("Failed to save the project. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Faield to save the project. Error " + response.error.message,
				3
			);
			return;
		}
		this.ui.editing = false;
		message.success("Succesfully saved the project", 3);
	});

	generateRandomInfo = flow(function*() {
		this.ui.generatingRandomInfo = true;
		let response = yield generateRandomInfo();
		let rawStateForm = this.getRawObjectFromFormObject(this.stateForm);
		_.mergeWith(rawStateForm, response, this.customizer);

		this.stateForm = observable.object(this.createFormObject(rawStateForm));
		this.ui.generatingRandomInfo = false;
	});

	downloadRankerXEmail = flow(function*() {
		this.ui.downloadingRankerXEmail = true;
		yield delay(500);
		const response = yield downloadRankerXEmail();
		this.ui.downloadingRankerXEmail = false;
		if (response == null) {
			message.error(
				"Failed to download pre-created email address. Unexpected error",
				3
			);
			return;
		}

		if (response.error) {
			message.error(
				"Failed to download pre-created email address. " +
					response.error.message,
				3
			);
			return;
		}
		message.success("Successfully downloaded pre-created email address");

		this.stateForm.verificationInfo = observable.object(
			this.createFormObject(response.emailSettings)
		);
	});

	downloadEmailFromEmailList = flow(function*() {
		this.ui.downloadingEmailFromEmailList = true;		
		const response = yield downloadEmailFromEmailList();
		this.ui.downloadingEmailFromEmailList = false;
		if (response == null) {
			message.error(
				"Failed to download email from email list. Unexpected error",
				3
			);
			return;
		}

		if (response.error) {
			Modal.error({
				title: "Failed to download email from email list",
				content: response.error.message,
				// placement: "topLeft"
			})
			// message.error(
			// 	"Failed to download email from email list. " + response.error.message,
			// 	3
			// );
			return;
		}
		message.success("Successfully downloaded email from email list");
	
		this.stateForm.verificationInfo = observable.object(
			this.createFormObject(response.emailSettings)
		);

		// this.projectViewModel.verificationInfo = observable.object(
		// 	response.emailSettings
		// );
		// this.stateForm = observable.object(
		// 	this.createStateForm(this.projectViewModel)
		// );
	});

	testEmail = flow(function*() {
		this.ui.testingEmail = true;
		const verificationInfo = this.getRawObjectFromFormObject(
			this.stateForm.verificationInfo
		);
		const response = yield testEmail(verificationInfo);
		this.ui.testingEmail = false;

		if (!response) {
			message.error("Failed to login the email address. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		message.success("Successfully logged in to the email address");
	});

	@action
	addProfile = profile => {
		this.profiles.push(profile);
	};

	@action
	showAddAccountProfileDialog = () => {
		this.ui.addAccountProfileDialogVisible = true;
	};

	@action
	hideAddAccountProfileDialog = () => {
		this.ui.addAccountProfileDialogVisible = false;
	};

	@action
	showAddEditScheduleDialog = () => {
		this.ui.addEditScheduleDialogVisible = true;
	};

	@action
	hideAddEditScheduleDialog = () => {
		this.ui.addEditScheduleDialogVisible = false;
	};

	@action
	saveSchedule = flow(function*(payload) {
		this.ui.savingSchedule = true;
		const params = {
			projectId: this.project.id,
			schedule: payload
		};
		const response = yield saveSchedule(params);
		this.ui.savingSchedule = false;

		if (response == null) {
			message.error("Failed to save schedule. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to save schedule. Error: " + response.error.message,
				3
			);
			return;
		}

		message.success("Successfully save the schedule", 3);

		this.ui.addEditScheduleDialogVisible = false;
	});

	@action
	deleteSchedule = flow(function*() {
		this.ui.deletingSchedule = true;
		const response = yield deleteSchedule(this.project.id);
		this.ui.deletingSchedule = false;

		if (!response) {
			message.error("Failed to delete schedule. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to delete schedule. Error: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully deleted the schedule", 3);
		this.ui.deletingSchedule = false;
	});

	@action
	resetSchedule = flow(function*() {
		this.ui.resettingSchedule = true;
		const response = yield resetSchedule(this.project.id);
		this.ui.resettingSchedule = false;

		if (!response) {
			message.error("Failed to reset schedule. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to reset schedule. Error: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully reset the schedule", 3);
	});

	@action
	addAccountProfile = flow(function*(payload) {
		this.ui.addingAccountProfile = true;
		const response = yield addAccountProfile({
			name: payload.name,
			campaignId: this.project.campaignId
		});

		this.ui.addingAccountProfile = false;

		if (response == null) {
			message.error("Failed to add new account profile. Unexpected error");
			return;
		}

		if (response.error) {
			message.error(response.error.message);
			return;
		}

		message.success("Successfully added new account profile");

		this.ui.addAccountProfileDialogVisible = false;
	});

	@action
	updateProjectStatus = payload => {
		// console.log("Update Project Status: " + JSON.stringify(payload));
		this.project.status = payload.status;
		this.stateForm.status = this.createFormObject(payload.status);
		this.project.lastError = payload.lastError;

		if (payload.schedule == null) {
			this.project.schedule = null;
		} else {
			this.project.schedule = observable.object(payload.schedule);
		}		
	};

	@action
	updateSiteStatus = payload => {
		this.ui.updatedSite = payload;
	};

	@action
	updateVerificationStatus = status => {
		// console.log(status);
		// set(this.project.verificationInfo, { status: status });		
		this.project.verificationInfo.status = status;
	};

	updateVerificationStatusDebounced = _.debounce(this.updateVerificationStatus, 200);

	startProject = flow(function*() {
		this.ui.startingProject = true;
		yield delay(1000);
		const response = yield startProject(this.project.id);
		// yield delay(1000);
		this.ui.startingProject = false;
		if (response == null) {
			message.error("Failed to start project. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to start project. Error is: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully started the project");
	});

	stopProject = flow(function*() {
		this.ui.stoppingProject = true;
		yield delay(1000);
		const response = yield stopProject(this.project.id);
		this.ui.stoppingProject = false;
		if (response == null) {
			message.error("Failed to stop project. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to stop project. Error is: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully stopped the project");
	});

	startVerifyingMails = flow(function*() {
		this.ui.startingVerifyingMails = true;
		const response = yield startVerifyingMails(this.project.id);
		this.ui.startingVerifyingMails = false;
		if (response == null) {
			message.error("Failed to start verifying mails. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to start verifying mails. Error is: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully started verifying mails");
	});

	stopVerifyingMails = flow(function*() {
		this.ui.stoppingVerifyingMails = true;
		const response = yield stopVerifyingMails(this.project.id);
		this.ui.stoppingVerifyingMails = false;
		if (response == null) {
			message.error("Failed to stop verifying mails. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(
				"Failed to stop verifying mails. Error is: " + response.error.message,
				3
			);
			return;
		}
		message.success("Successfully stopped verifying mails");
	});

	createFormObject = project => {
		function customizer(value, key) {
			if (!_.isObject(value) && key !== "value") {
				return {
					value: value
				};
			}

			if (_.isArray(value)) {				
				return _.cloneDeep(value);				
			}
		}

		let newObj = _.cloneDeepWith(toJS(project), customizer);
		return newObj;
	};

	fetchProject = flow(function*(projectId) {
		this.ui.loadingProject = true;
		// console.log("Loading Project");
		const response = yield getProject({ projectId });
		// console.log("Done loading project");
		if (response != null) {
			const project = response.project;
			if (
				project.verificationInfo == undefined ||
				project.verificationInfo == null
			) {
				project.verificationInfo = {
					status: null
				};
			}
			// console.log("Project is", project);
			this.project = observable.object(project);
			this.campaign = observable.object(response.campaign);
			this.siblings = observable.array(response.siblings);
			this.sites = observable.array(response.sites, { deep: false });
			this.profiles = observable.array(response.profiles);
			this.stateForm = observable.object(this.createFormObject(project));
			this.ui = observable.object(this.getInitUI());
			this.uuid = uuidv1();

			registerHandler([
				{
					path: "project/" + this.project.id,
					handler: function(err, msg) {
						if (err) {
							return;
						}

						var obj = JSON.parse(msg.body);
						if (obj.action === "projectStatusChanged") {
							this.updateProjectStatus({
								status: obj.status,
								lastError: obj.lastError,
								schedule: obj.schedule
							});
							return;
						}
						// if (obj.action === "projectSaved") {
						//   if (obj.uuid != state.uuid) {
						//     window.location.reload();
						//   }
						//   return;
						// }
						if (obj.action === "siteStatusChanged") {
							this.updateSiteStatus(obj.site);
							return;
						}
						if (obj.action == "verificationProgressed") {
							this.updateVerificationStatusDebounced(obj.status);
							return;
						}
					}.bind(this)
				},
				{
					path: "campaign/" + project.campaignId,
					handler: function(err, msg) {
						if (err) {
							return;
						}
						let obj = JSON.parse(msg.body);
						if (obj.action == "newProfile") {
							let newProfile = obj.profile;
							this.addProfile(newProfile);
						}
					}.bind(this)
				}
				// {
				//   path: "campaign/" + projectId,
				//   handler: (err, message) => {}
				// }
			]);
		}
	});
}
